import { render, staticRenderFns } from "./PersonOneWorkingRetired.vue?vue&type=template&id=87163122&"
import script from "./PersonOneWorkingRetired.vue?vue&type=script&lang=js&"
export * from "./PersonOneWorkingRetired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports